import { createContext, useContext, useState, useEffect } from "react";
import {
  loadOrdenes,
  saveOrdenes,
  loadMesaSeleccionada,
  saveMesaSeleccionada,
  clearMesaSeleccionada,
} from "../../../core/mesas/mesaService.js";

const MesaContext = createContext();
export const useMesa = () => useContext(MesaContext);

export const MesaProvider = ({ children }) => {
  const [mesaSeleccionada, setMesaSeleccionada] = useState(null);
  const [ordenesPorMesa, setOrdenesPorMesa] = useState({});

  const [mesasDisponibles] = useState([
    { id: 1, nombre: "Mesa 1", estado: "libre" },
    { id: 2, nombre: "Mesa 2", estado: "libre" },
    { id: 3, nombre: "Mesa 3", estado: "libre" },
    { id: 4, nombre: "Mesa 4", estado: "libre" },
    { id: 5, nombre: "Mesa 5", estado: "libre" },
    { id: 6, nombre: "Mesa 6", estado: "libre" },
    { id: 7, nombre: "Mesa 7", estado: "libre" },
    { id: 8, nombre: "Mesa 8", estado: "libre" },
  ]);

  // ------------------------------------------
  // PERSISTENCIA en LOCAL STORAGE
  // ------------------------------------------
  useEffect(() => {
    setOrdenesPorMesa(loadOrdenes());
    setMesaSeleccionada(loadMesaSeleccionada());
  }, []);

  useEffect(() => {
    saveOrdenes(ordenesPorMesa);
  }, [ordenesPorMesa]);

  useEffect(() => {
    if (mesaSeleccionada !== null) {
      saveMesaSeleccionada(mesaSeleccionada);
    }
  }, [mesaSeleccionada]);

  // ------------------------------------------
  // FUNCIONES DE ÓRDENES
  // ------------------------------------------
  const guardarOrdenMesaContext = (mesaId, productos) => {
    setOrdenesPorMesa((prev) => {
      const ordenNueva = {
        productos,
        total: productos.reduce((acc, p) => acc + p.subtotal, 0),
        fecha: new Date().toISOString(),
      };
      return {
        ...prev,
        [mesaId]: [...(prev[mesaId] || []), ordenNueva],
      };
    });
  };

  const mesaTieneOrdenes = (mesaId) => ordenesPorMesa[mesaId]?.length > 0;

  const eliminarOrdenesDeMesa = (mesaId) => {
    setOrdenesPorMesa((prev) => {
      const copia = { ...prev };
      delete copia[mesaId];
      return copia;
    });
  };

  // esta es la funcion para eliminar una orden especifica dentro de una mesa, recibe el id de la mesa y el index de la orden a eliminar dentro del array de ordenes de esa mesa
  const eliminarOrdenDeMesa = (mesaId, index) => {
    setOrdenesPorMesa((prev) => {
      const copia = { ...prev };

      // Filtrar la orden específica
      copia[mesaId] = copia[mesaId].filter((_, i) => i !== index);

      // Si la mesa queda vacía, eliminarla
      if (copia[mesaId].length === 0) {
        delete copia[mesaId];
      }

      return copia;
    });
  };

  const eliminarTodasLasOrdenes = () => setOrdenesPorMesa({});

  // ------------------------------------------
  // FUNCIONES DE MESAS
  // ------------------------------------------
  const seleccionarMesa = (id) => {
    const mesa = mesasDisponibles.find((m) => m.id === id);
    if (mesa && mesa.estado === "libre") {
      setMesaSeleccionada(id);
    }
  };

  const limpiarMesa = () => {
    setMesaSeleccionada(null);
    clearMesaSeleccionada();
  };

  // ------------------------------------------
  // EXPORTAR CONTEXTO
  // ------------------------------------------
  return (
    <MesaContext.Provider
      value={{
        mesaSeleccionada,
        mesasDisponibles,
        ordenesPorMesa,
        seleccionarMesa,
        limpiarMesa,
        guardarOrdenMesaContext,
        mesaTieneOrdenes,
        eliminarOrdenesDeMesa,
        eliminarOrdenDeMesa,
        eliminarTodasLasOrdenes,
      }}
    >
      {children}
    </MesaContext.Provider>
  );
};
